import { selectCurrentUserId } from "../local";

import {
  selectAssignedBreakoutRoomForCurrentUser,
  selectBreakoutRoomsForActiveBreakout,
} from "./breakout";

import { RootState } from "shared/types";
import { RoleType } from "shared/types/user";
import { longDisplayName } from "utils/user";

export const selectChatById = (chatId?: string) => (state: RootState) =>
  chatId ? state.classroom.client.chats[chatId] : undefined;

export const selectChats = () => (state: RootState) => Object.values(state.classroom.client.chats);

export const selectChatIds = () => (state: RootState) => Object.keys(state.classroom.client.chats);

export const selectMentionableTags = () => (state: RootState) => {
  const users = state.classroom.client.users;
  const currentUserId = selectCurrentUserId()(state);
  const canMentionEveryoneInChat =
    state.classroom.client.capabilities.canMentionEveryoneInChat.includes(currentUserId);

  const tags = Object.values(users)
    .filter((user) => user.is_present && user.id !== currentUserId)
    .map((user) => `@${longDisplayName(user)}`)
    .sort();

  const captionerIsPresent = Object.values(users).some(
    (user) => user.is_present && user.role === RoleType.Captioner,
  );
  if (captionerIsPresent) {
    tags.unshift("@Captioner");
  }
  if (canMentionEveryoneInChat) {
    tags.unshift("@All");
  }

  // If a breakout is active, add breakout room tags
  const active_breakout_session_id = state.classroom.client.active_breakout_session_id;
  if (active_breakout_session_id) {
    const breakoutRooms = [];
    if (canMentionEveryoneInChat) {
      breakoutRooms.push(...selectBreakoutRoomsForActiveBreakout()(state));
    } else {
      const assignedBreakoutRoom = selectAssignedBreakoutRoomForCurrentUser()(state);
      if (assignedBreakoutRoom) {
        breakoutRooms.push(assignedBreakoutRoom);
      }
    }
    const breakoutRoomTags = breakoutRooms.map((room) => `@Group ${room.title}`);
    breakoutRoomTags.sort();
    tags.push(...breakoutRoomTags);
  }

  return tags;
};
